<template>
  <div>
    <mdb-modal size="lg" @shown="componentDidMount" :show="visible"  @close="onClose">
      <mdb-modal-header>
        <mdb-modal-title>{{focus_user?focus_user.name:"User"}} Promo Codes</mdb-modal-title>
      </mdb-modal-header>
      <mdb-modal-body>
        <mdb-container>
            <mdb-row>
              <mdb-col col="8">
                <select v-model="selected_promo_code" class="browser-default custom-select">
                  <option value="" selected disabled>Select Promo Code</option>
                  <option v-for="promo in selection_promo_codes" v-bind:key="promo.id" :value="promo.id">{{promo.code}}</option>
                </select>
              </mdb-col>
              <mdb-col col="4">
                <mdb-btn v-if="!promo_code_loading" @click="submitPromoCode" color="primary" size="sm">
                  Submit
                </mdb-btn>
                <mdb-spinner v-if="promo_code_loading" />
              </mdb-col>
            </mdb-row>
            <mdb-row>
              <mdb-col col="12" class="mt-3">
                <div class="d-flex flex-row align-items-center">
                  <span class="icon-status" style="background-color: #e8f5e9" /> Available
                  <span class="icon-status" style="background-color: #e1f5fe; margin-left: 10px" /> Used
                  <span class="icon-status" style="background-color: #FFEBEE; margin-left: 10px" /> Expired
                </div>
              </mdb-col>
            </mdb-row>
            <hr />
            <mdb-row>
                <mdb-col md="6" v-for="promo_code in promo_codes" v-bind:key="promo_code.id">
                  <div class="promo-code-container" :style="{'background-color': checkValidity(promo_code)}">
                    <div class="font-weight-bold"><mdb-icon icon="percentage" style="margin-right: 5px" />{{promo_code.promo_code_config.code}} <span v-if="promo_code.order_number">({{promo_code.order_number}})</span></div>
                    <div v-if="promo_code.promo_code_config.amount!='0.00'">RM {{promo_code.promo_code_config.amount}}</div>
                    <div v-if="promo_code.promo_code_config.amount_percentage!='0.00'">{{promo_code.promo_code_config.amount_percentage*100}}% (RM {{promo_code.promo_code_config.amount_cap}})</div>
                    <div class="small">Expiry Date: {{momentFormatDate(promo_code.expired_at)}}</div>
                    <div class="small">Created Date: {{momentFormatDate16(promo_code.created_at)}}</div>
                    <mdb-btn v-if="checkCanDelete(promo_code)" @click="withdrawCustomerVoucher(promo_code)" color="danger" size="sm" class="withdrawal-btn" ><mdb-icon icon="eraser" /></mdb-btn>
                  </div>
                </mdb-col>
            </mdb-row>
        </mdb-container>
      </mdb-modal-body>
      <mdb-modal-footer>
        <mdb-spinner v-if="loading" />
        <mdb-btn v-if="!loading" @click="onClose" color="danger">Close</mdb-btn>
      </mdb-modal-footer>
    </mdb-modal>
  </div>
</template>

<script>
    import { mdbModal, mdbModalHeader, mdbModalTitle, mdbModalFooter, mdbBtn, mdbModalBody, mdbContainer, mdbRow, 
    mdbCol, mdbSpinner, mdbIcon} from 'mdbvue';
    import {ajax} from '../js/ajax';
    import {momentFormatDate, momentFormatDate16, checkPermissionsBinary} from '../js/helper';

    export default {
        components: {
        mdbModal,
        mdbModalHeader,
        mdbModalTitle,
        mdbModalFooter, mdbIcon,
        mdbBtn, mdbContainer, mdbRow, mdbCol,
        mdbModalBody, mdbSpinner
        },
        props: ['visible', 'close', 'focus_user', 'selection_promo_codes'],
        data: ()=>({
          loading:false,
          selected_promo_code: "",
          promo_codes: [],
          promo_code_loading: false
        }),
        methods: {
          componentDidMount(){
            if(!checkPermissionsBinary(63, this.$store.state.permissions)){
              this.$notify.error({message: "Access Denied.", position: 'top right', timeOut: 5000})
              return;
            }
            this.getData();
          },
          getData(){
            this.loading=true;
            ajax({
              url: "admin/get_user_promo_code",
              data: {user_id: this.focus_user.id},
              complete: ()=>this.loading=false,
              success:result=>{
                this.promo_codes=result.data;
              },
            }, this)
          },
          onClose(){
            this.selected_promo_code="";
            this.promo_codes=[];
            this.close();
          },
          submitPromoCode(){
            if(!checkPermissionsBinary(65, this.$store.state.permissions)){
              this.$notify.error({message: "Access Denied.", position: 'top right', timeOut: 5000})
              return;
            }
            if(!this.selected_promo_code){
              return false;
            }
            this.promo_code_loading=true;
            ajax({
              url: "admin/submit_promo_code_to_user",
              data: {user_id: this.focus_user.id, promo_code_id: this.selected_promo_code},
              complete: ()=>this.promo_code_loading=false,
              success: ()=>{
                this.selected_promo_code="";
                this.$notify.success({message: "Promo Code has been added", position:'top right', timeOut: 5000});
                this.getData();
              },
            }, this)
          },
          momentFormatDate(date){
            return momentFormatDate(date);
          },
          momentFormatDate16(date){
            return momentFormatDate16(date);
          },
          checkValidity(promo_code){
            if(promo_code.is_used==1){
              return '#e1f5fe';
            }
            let expired_at = new Date(promo_code.expired_at)
            if(new Date() > expired_at){
              return '#FFEBEE';
            }
            return '#e8f5e9';
          },
          checkCanDelete(promo_code){
            if(promo_code.is_used==1){
              return false;
            }
            let expired_at = new Date(promo_code.expired_at)
            if(new Date() > expired_at){
              return false;
            }
            return true;
          },
          withdrawCustomerVoucher(promo){
            if(!checkPermissionsBinary(64, this.$store.state.permissions)){
              this.$notify.error({message: "Access Denied.", position: 'top right', timeOut: 5000})
              return;
            }
            this.promo_code_loading=true;
            ajax({
              url: "admin/withdraw_customer_voucher",
              data: {id: promo.id},
              complete: ()=>this.promo_code_loading=false,
              success: ()=>{
                this.$notify.success({message: "Promo Code has been deleted.", position:'top right', timeOut: 5000});
                this.getData();
              },
            }, this)
          }
        },
    };
</script>

<style scoped>
.promo-code-container{
  border: 1px solid #000;
  margin: 0 0.5rem 0.5rem 0.5rem;
  padding: 0.5rem;
  border-radius: 10px;
}
.icon-status{
  height: 15px;
  width: 15px;
  margin-right: 5px;
  border-radius: 5px;
  border: 1px solid #9e9e9e;
}

.withdrawal-btn{
  position: absolute;
  top: 0;
  right: 30px;
  z-index: 100;
}
</style>